import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchExploreGridBox, fetchExploreInfoBox } from './thunk/exploreThunk';

const initialState = {
  titleObj: null,
  titleObjRequestStatus: '',
  keywordGridData: null,
};

export const keywordExploreSlice = createSlice({
  name: 'keywordExplore',
  initialState: initialState,
  reducers: {},
  extraReducers: {
    // InfoBox fetch
    [fetchExploreInfoBox.fulfilled.type]: (state, { payload, meta: { requestStatus } }) => {
      state.titleObj = payload;
      state.titleObjRequestStatus = requestStatus;
    },
    [fetchExploreInfoBox.pending.type]: (state, { meta: { requestStatus } }) => {
      state.titleObjRequestStatus = requestStatus;
    },
    [fetchExploreInfoBox.rejected.type]: (state, { meta: { requestStatus } }) => {
      state.titleObjRequestStatus = requestStatus;
    },

    // gridDataBox fetch
    [fetchExploreGridBox.fulfilled.type]: (state, { payload, meta: { requestStatus } }) => {
      state.keywordGridData = payload;
    },
  },
});

export const keywordExploreSliceName = keywordExploreSlice.name;
export default keywordExploreSlice.reducer;
